module.exports = __webpack_public_path__ + "img/1559970655.ce091068.jpg";